// @owners { team: patients-team }
import { createSelector } from 'reselect';
import getDeliveriesForShipmentID from '~shared/features/delivery-info/selectors/getDeliveriesForShipmentID';
import { getShipmentWithID } from '~shared/features/shipments/selectors/getShipments';
import type { OrderPricingQueryData } from '~shared/queries/useOrderPricing';
import { type ReduxStateShared } from '~shared/types';

type RemovingWillAddFeeProps = {
  deliveryID: number;
  minimumThresholdToWaiveFee: number;
  orderPricing?: OrderPricingQueryData;
};

const getDeliveryID = (_: ReduxStateShared, { deliveryID }: RemovingWillAddFeeProps) => deliveryID;
const getMinimumThresholdToWaiveFee = (_: ReduxStateShared, { minimumThresholdToWaiveFee }: RemovingWillAddFeeProps) =>
  minimumThresholdToWaiveFee;

const getOrderPricing = (_: ReduxStateShared, { orderPricing }: RemovingWillAddFeeProps) => orderPricing;

export const getRemovingDeliveryWillAddDeliveryFee = createSelector(
  [getDeliveriesForShipmentID, getShipmentWithID, getDeliveryID, getMinimumThresholdToWaiveFee, getOrderPricing],
  (deliveries, shipment, deliveryID, minimumThresholdToWaiveFee, orderPricing) => {
    if (!shipment) return false;

    const remainingDeliveries = deliveries.filter((delivery) => delivery.id !== deliveryID);

    const remainingPrice = remainingDeliveries.reduce((sum, item) => {
      const price = item.prescription?.id ? orderPricing?.item_pricing[item.prescription.id]?.prices[0]?.price : 0;
      return sum + (price || 0);
    }, 0);

    return remainingPrice < minimumThresholdToWaiveFee;
  },
);
